import(/* webpackMode: "eager", webpackExports: ["HomePage"] */ "/home/buyme/htdocs/buyme.lk/src/components/HomePage.tsx");
